<!--

  タイトル
    * 1.0 2018/11/01 Create Ryo Imai

  detail:
    ログアウトページ
    この端末のみログアウトか、全ての端末のセッションをログアウトするか選べる

-->
<template>
  <div>
    <div class="mb-3">
      <v-btn
        variant="outlined"
        color="secondary"
        @click="logoutThisSession"
      >
        {{ $t('LogoutPage.LogoutThisSessionOnly') }}
      </v-btn>
    </div>
    <v-divider />
    <div class="mt-3">
      <v-btn
        variant="outlined"
        color="secondary"
        @click="logoutAllSessions"
      >
        {{ $t('LogoutPage.LogoutAllSessions') }}
      </v-btn>
    </div>
  </div>
</template>

<script>
  import { allSessions, thisSession } from '../../library/logout'

  export default {
    components: {},
    props: {},
    data: () => ({}),
    computed: {},
    watch: {},
    created () {},
    mounted () {},
    methods: {
      deleteProfile () {
        this.$store.dispatch('login', { user_id: null, profile: {} })
      },
      logoutThisSession () {
        this.deleteProfile()
        thisSession()
      },
      logoutAllSessions () {
        this.deleteProfile()
        allSessions()
      }
    }
  }
</script>

<style scoped>

</style>
